import axiosInstance from 'api/axiosInstance';

export const getGuardContacts = async () => {
	const url = `/api/cantrackv3/SContactTypeEmployees?Id=0&SearchKeyword=&Page=1&Take=999`;
	const response = await axiosInstance.get(url);
	const guardContacts = response.data;
	return guardContacts;
};
